import { useLenis } from "lenis/react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const lenis = useLenis();

  return (
    <footer className="border-t border-cyan-500/10 bg-[#080C14] py-14" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 sm:px-6 md:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center">
            <img src="/logo-v2.png" alt="KLMProd" className="h-10 w-auto" />
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
            DJ & animation musicale pour mariages, soirées privées et séminaires. Votre soirée,
            votre musique, notre métier.
          </p>
        </div>

        <div>
          <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Navigation</p>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {[
              ["Formules", "#formules"],
              ["Méthode", "#methode"],
              ["Playlist", "#playlist"],
              ["Infos pratiques", "#infos"],
              ["Conditions", "#conditions"],
              ["Devis", "#devis"],
            ].map(([label, href]) => (
              <button
                key={href}
                data-testid={`footer-link-${href.slice(1)}`}
                onClick={() => lenis?.scrollTo(href, { offset: -72, duration: 1.3 })}
                className="w-fit text-sm text-slate-400 transition-colors duration-300 hover:text-cyan-300"
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Prestations</p>
          <div className="mt-4 flex flex-col gap-2">
            {[
              ["DJ mariage Drôme", "/dj-mariage-drome"],
              ["DJ mariage Vaucluse", "/dj-mariage-vaucluse"],
              ["Soirée d'entreprise", "/soiree-entreprise-drome-ardeche"],
              ["Anniversaire haut de gamme", "/anniversaire-haut-de-gamme"],
              ["Tarifs & formules", "/tarifs"],
              ["Notre matériel", "/materiel"],
              ["Blog", "/blog"],
            ].map(([label, to]) => (
              <Link
                key={to}
                to={to}
                data-testid={`footer-seo-${to.slice(1)}`}
                className="w-fit text-sm text-slate-400 transition-colors duration-300 hover:text-cyan-300"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Votre projet</p>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Devis gratuit et sans engagement.
            <br />
            Réponse garantie sous 48 h.
          </p>
          <a
            href="mailto:contact@klmprod.com"
            data-testid="footer-email-link"
            className="mt-3 block text-sm font-semibold text-cyan-300 transition-colors hover:text-cyan-200"
          >
            contact@klmprod.com
          </a>
          <button
            data-testid="footer-cta-devis"
            onClick={() => lenis?.scrollTo("#devis", { offset: -72, duration: 1.4 })}
            className="group mt-4 flex items-center gap-1.5 text-sm font-bold text-cyan-300 transition-colors hover:text-cyan-200"
          >
            Lancer ma demande
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-center justify-between gap-3 border-t border-cyan-500/10 px-4 pt-6 text-xs text-slate-600 sm:flex-row sm:px-6 lg:px-8">
        <span>© 2026 KLMProd — Tous droits réservés · SIRET 339 222 140 40065 · APE 7021Z</span>
        <Link to="/mentions-legales" data-testid="footer-legal-link" className="transition-colors hover:text-cyan-400">
          Mentions légales
        </Link>
        <span>Assurance annulation & intempéries recommandée pour tout événement en extérieur.</span>
      </div>
    </footer>
  );
}
